import { CssBaseline } from '@mui/material'
import { StyledEngineProvider, ThemeProvider } from '@mui/system'
import ProtectedRoute from 'components/authentication/ProtectedRoute'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import routes from 'routes'
import { appTitleKOR } from 'store/baseConfig'
import theme from 'themes'


const App = () => {
  const customization = useSelector((state) => state.customization);

  const router = createBrowserRouter(
    routes.map(route => {
      if (route.protected) {
        return {
          ...route,
          element: (
            <ProtectedRoute allowedRoles={route.allowedRoles}>
              {route.element}
            </ProtectedRoute>
          ),
          children: route.children ? route.children.map(child => {
            // child의 protected 속성이 없을 경우 상위 route의 속성을 참조
            const isProtected = child.protected !== undefined ? child.protected : route.protected;
            const allowedRoles = child.allowedRoles || route.allowedRoles;
  
            return {
              ...child,
              element: isProtected ? (
                <ProtectedRoute allowedRoles={allowedRoles}>
                  {child.element}
                </ProtectedRoute>
              ) : (
                child.element
              ),
            };
          }) : undefined,
        };
      }
      return route;
    })
  );

  return (
    <StyledEngineProvider injectFirst>
      <Helmet>
        <title>{appTitleKOR}</title>
      </Helmet>
      <ThemeProvider theme={theme(customization)}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App
